import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ApiUser, ApiUserCreate, ApiUserFilter } from '../data/user';

export function createUserService(client: AxiosInstance) {
  return createCrudService<ApiUser, ApiUserCreate, ApiUserFilter>(client, '/User', 'userId');
}

export type ApiUserService = CrudService<ApiUser, ApiUserCreate, ApiUserFilter>;
